import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { PvArrowBack, PvBox, PvLinkGreen } from 'styles/CustomComponents';
import styled from 'styled-components';

const StickyPreviousLink = styled(PvBox)`
  position: ${props => props.sticky && 'fixed'}
  background: ${props => props.sticky && props.theme.colors.lighten[5]};
  top: ${props => props.sticky && '0'};
  width: ${props => props.sticky && '100%'};
  transition: padding-top .5s ease;
  padding: ${props => props.sticky && `${props.theme.space[2]}px`};
  padding-right: 0;
  padding-left: 0;
`;

class PreviousLink extends React.Component {
  render() {
    const { isSticky, previousFn, previousText, mb } = this.props;
    return (
      <StickyPreviousLink sticky={isSticky ? 'true' : undefined} mb={mb}>
        <PvLinkGreen href='#' onClick={(e) => {
          e.preventDefault();
          previousFn();
        }}>
          <PvArrowBack />
          <Translate value={previousText || 'action.previous'} />
        </PvLinkGreen>
      </StickyPreviousLink>
    );
  }
}

PreviousLink.propTypes = {
  isSticky: PropTypes.bool,
  previousFn: PropTypes.func.isRequired,
  previousText: PropTypes.string,
};

export default PreviousLink;


// WEBPACK FOOTER //
// ./src/components/PreviousLink.jsx